import { defineStore } from 'pinia';

export interface PopupNotification {
    type: 'error' | 'success' | 'action'
    title: string
    permanent: boolean
    actionText?: string
    action?: () => void
}

const DISMISS_AFTER_MS = 6300;

export const usePopupNotificationsStore = defineStore('popupNotifications', {
    state: (): { notifications: PopupNotification[] } => ({
        notifications: [],
    }),
    getters: {
        getNotifications: state => state.notifications,
    },
    actions: {
        newPopupNotification(notification: PopupNotification): void {
            // Repeat submissions of the same failing request would otherwise stack
            // identical toasts on top of each other.
            const mostRecent = this.notifications[this.notifications.length - 1];
            if (mostRecent?.title === notification.title) {
                return;
            }

            this.notifications.push(notification);

            if (!notification.permanent) {
                setTimeout(() => {
                    this.removePopupNotification(notification);
                }, DISMISS_AFTER_MS);
            }
        },
        removePopupNotification(notification: PopupNotification): void {
            const index = this.notifications.indexOf(notification);
            if (index !== -1) {
                this.notifications.splice(index, 1);
            }
        },
    },
});
